/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState, useEffect } from 'react';
import { withFirebase } from 'library/Firebase';
import { bp, mq } from 'constants/mediaQueries';
import {
  Route,
  Switch,
  useRouteMatch,
  useHistory,
  useLocation,
} from 'react-router-dom';
import qs from 'query-string';
import { formInput, button } from 'theme/styleBlocks';
import UserCard from './UserCard/UserCard';

const UserSearch = ({ firebase }) => {
  const [searchBy, setSearchBy] = useState('name');
  const [search, setSearch] = useState('');
  const [type, setType] = useState('workers');
  const [users, setUsers] = useState([]);
  // const [edit, setEdit] = useState(false);
  const [searching, setSearching] = useState(false);
  const [noneFound, setNoneFound] = useState(false);

  const location = useLocation();
  const { path } = useRouteMatch();
  const history = useHistory();

  const parsed = qs.parse(location.search);

  useEffect(() => {
    if (
      parsed.search &&
      (parsed.searchBy === 'name' ||
        parsed.searchBy === 'id' ||
        parsed.searchBy === 'email') &&
      (parsed.type === 'workers' || parsed.type === 'businesses')
    ) {
      firebase
        .searchUser(parsed.type, parsed.searchBy, parsed.search)
        .then((data) => {
          setUsers(data);
          setSearching(false);
          if (data.length <= 0) {
            setNoneFound(true);
          }
        });
    }
    // let unsub;
    // const getUserData = async () => {
    //   const searchUser = await firebase.searchUser(
    //     parsed.type,
    //     parsed.searchBy,
    //     parsed.search
    //   );
    //   unsub = searchUser.onSnapshot((snapshot) => {
    //     const data = [];
    //     snapshot.forEach((doc) => {
    //       data.push(doc.data());
    //     });
    //     setUsers(data);
    //     setSearching(false);
    //     if (data.length <= 0) {
    //       setNoneFound(true);
    //     }
    //   });
    // };
    // if (
    //   parsed.search &&
    //   (parsed.searchBy === 'name' || parsed.searchBy === 'email') &&
    //   (parsed.type === 'workers' || parsed.type === 'businesses')
    // ) {
    //   getUserData();
    // } else {
    //   history.push(path);
    // }

    // return () => {
    //   if (unsub) unsub();
    // };
  }, [firebase, parsed.search, parsed.searchBy, parsed.type]);
  useEffect(() => {
    if (parsed.type === 'workers' || parsed.type === 'businesses') {
      setType(parsed.type);
    }
    if (
      parsed.searchBy === 'name' ||
      parsed.searchBy === 'id' ||
      parsed.searchBy === 'email'
    ) {
      setSearchBy(parsed.searchBy);
    }
    setSearch(parsed.search || '');
  }, [parsed.search, parsed.searchBy, parsed.type]);
  const searchUser = () => {
    setSearching(true);
    setNoneFound(false);
    history.push(`${path}?type=${type}&searchBy=${searchBy}&search=${search}`);
    // setSearchQuery([type, searchBy, search]);
    // return firebase.searchUser(type, searchBy, search).then((data) => {
    //   setUsers(data);
    //   setSearching(false);
    //   if (data.length <= 0) {
    //     setNoneFound(true);
    //   }
    // });
  };
  const selectUser = (id) => {
    history.push(`${path}/${type}/${id}`);
  };
  // const onEdit = () => {
  //   setEdit(true);
  //   if (edit === true) {
  //     setEdit(false);
  //   }
  // };
  return (
    <Switch>
      <Route exact path={path}>
        <div
          css={{
            margin: '0 auto',
            padding: '0 20px',
            marginTop: 50,
            [mq(bp.large)]: {
              padding: 0,
              marginTop: 90,
              maxWidth: 1020,
            },
          }}
        >
          <h3>Type</h3>
          <div
            css={{
              display: 'flex',
              margin: '0 auto',
              '&>div': { marginRight: 20 },
            }}
          >
            <div>
              <label htmlFor="worker">Worker</label>
              <input
                type="radio"
                name="type"
                id="workers"
                value="workers"
                checked={type === 'workers'}
                onChange={(e) => setType(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="businesses">Business</label>
              <input
                type="radio"
                name="type"
                id="businesses"
                value="businesses"
                checked={type === 'businesses'}
                onChange={(e) => setType(e.target.value)}
              />
            </div>
          </div>
          <h3 css={{ marginTop: 30 }}>Search By</h3>
          <div
            css={{
              display: 'flex',
              marginBottom: 20,
              '&>div': { marginRight: 20 },
            }}
          >
            <div>
              <label htmlFor="searchByName">Name (First Name)</label>
              <input
                type="radio"
                name="searchBy"
                id="searchByName"
                value="name"
                checked={searchBy === 'name'}
                onChange={(e) => setSearchBy(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="searchByID">ID</label>
              <input
                type="radio"
                name="searchBy"
                id="searchByID"
                value="id"
                checked={searchBy === 'id'}
                onChange={(e) => setSearchBy(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="searchByEmail">Email</label>
              <input
                type="radio"
                name="searchBy"
                id="searchByEmail"
                value="email"
                checked={searchBy === 'email'}
                onChange={(e) => setSearchBy(e.target.value)}
              />
            </div>
          </div>
          <div
            css={{
              marginTop: 50,
              [mq(bp.large)]: {
                display: 'grid',
                gridTemplateColumns: '2fr 1fr',
                columnGap: '40px',
                alignItems: 'center',
              },
            }}
          >
            <div css={[formInput, { marginBottom: '0' }]}>
              <input
                type="text"
                name="search"
                id="search"
                onChange={(e) => setSearch(e.target.value)}
                value={search}
              />
            </div>
            <button
              type="button"
              css={(theme) =>
                button(
                  theme.buttons.type_dark,
                  theme.buttons.bg2,
                  theme.buttons.hover2
                )
              }
              onClick={searchUser}
            >
              Search
            </button>
          </div>
          {searching ? <p>Searching...</p> : null}
          {!searching && noneFound ? <p>No Users Found</p> : null}
          {!searching && !noneFound && users.length > 0 ? (
            <div>
              {users.map((user) => (
                <div
                  css={{
                    marginTop: 50,
                    [mq(bp.large)]: {
                      display: 'grid',
                      gridTemplateColumns: '2fr 1fr',
                      columnGap: '40px',
                      alignItems: 'end',
                    },
                  }}
                >
                  <div>
                    <p>
                      Name: {user.firstName} {user.lastName}
                    </p>
                    <p>Email: {user.email}</p>
                    <p>ID: {user.uid}</p>
                  </div>
                  <button
                    type="button"
                    onClick={() => selectUser(user.uid)}
                    css={(theme) =>
                      button(
                        theme.buttons.type_dark,
                        theme.buttons.bg2,
                        theme.buttons.hover2
                      )
                    }
                  >
                    Edit
                  </button>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </Route>
      <Route
        path={`${path}/:type/:id`}
        render={() => <UserCard type={type} />}
      />
    </Switch>
  );
};

export default withFirebase(UserSearch);
